export default __webpack_public_path__ + "static/social-banner-a7000ca102f1fe4e70c25f9e9900a5e3.png";